import { fg } from '@atlaskit/platform-feature-flags/fg';

import { QueryIntent } from '../constants';

export function getFrontendQueryIntent(
	query: string,
): { queryIntent: QueryIntent; transformedQuery: string } | undefined {
	const lowercaseQuery = query.toLowerCase();

	if (/^[a-z][a-z0-9_]+-\d+$/.test(lowercaseQuery) && fg('kd_restrict_jira_issue_query_intent')) {
		return {
			queryIntent: QueryIntent.JIRA_ISSUE,
			transformedQuery: query,
		};
	}

	if (/\w+-\d+/.test(lowercaseQuery) && !fg('kd_restrict_jira_issue_query_intent')) {
		return {
			queryIntent: QueryIntent.JIRA_ISSUE,
			transformedQuery: query,
		};
	}

	if (lowercaseQuery.endsWith(' agent') || lowercaseQuery.endsWith(' agents')) {
		return {
			queryIntent: QueryIntent.AGENT,
			transformedQuery: query.replace(' agent', '').replace(' Agent', ''),
		};
	}
}
